import { Stack, ButtonGroup, Button, Modal, ModalClose, ModalDialog, Tooltip} from '@mui/joy';
import { Lock, LockOpen, QuestionMark, RateReview, Storage} from '@mui/icons-material';
import FinalStateSelector from './FinalStateSelector';
import FilterBar from './FilterBar';
import MessageBoard from './MessageBoard';
import { useDispatch, useSelector } from 'react-redux';
import SaveButton from './SaveButton';
import UploadButton from './UploadButton';
import React from 'react';
import CheckSetup from './CheckSetup';
import SettingsModal from './Settings';
import BackendSelector from './BackendSelector';

export default function TopBar(){
    const dispatch = useDispatch();
    const locked = useSelector(state => state.decayLock);
    const currentBackend = useSelector(state => state.backend.currentBackend);
    const [help, setHelp] = React.useState(false);
    const [backendModal, setBackendModal] = React.useState(false);

    const issueUrl = `https://github.com/KaiHabermann/decayamplitude/issues/2`;
    const handleLockToggle = () => {
        dispatch({ type: 'TOGGLE_DECAY_LOCK' });
    }

    const handleBackendSelect = (backend) => {
        console.log('Selected backend:', backend);
        // You can add additional logic here if needed
        // The backend is already set in the Redux store by the BackendSelector
    }


    return (
        <React.Fragment>
        <Modal open={help} onClose={() => setHelp(false)}>
            <ModalDialog>
            <ModalClose/>
            <img
              src={
                "./Help.png"
              }
              alt="help"
            />
            </ModalDialog>
        </Modal>
        <Stack spacing={2} direction="row" justifyContent={"space-between"} padding={2} alignItems="center">
            <FinalStateSelector />
            <div style={{ minWidth: '15vw' }}>
                <FilterBar />
            </div>
            <ButtonGroup>
                <MessageBoard/>
                <SettingsModal />
                <CheckSetup/>
                <Tooltip title={`Backend: ${currentBackend || 'Not selected'}`} placement="top">
                    <Button 
                        variant="outlined" 
                        onClick={() => setBackendModal(true)}
                        color={currentBackend ? 'success' : 'neutral'}
                    >
                        <Storage/>
                    </Button>
                </Tooltip>
                <Tooltip title="Suggestions" placement="top">
                    <Button variant="outlined" onClick={() => window.open(issueUrl, "_blank")}>
                        <RateReview/>
                    </Button>
                </Tooltip>
                <Tooltip title="Lock/Unlock Decay" placement="top">
                    <Button variant="outlined" onClick={handleLockToggle}>
                        {locked ? <Lock></Lock> : <LockOpen></LockOpen>}
                    </Button>
                </Tooltip>
                <SaveButton></SaveButton>
                <UploadButton></UploadButton>
            </ButtonGroup>

        </Stack>
        
        <BackendSelector 
            open={backendModal}
            onClose={() => setBackendModal(false)}
            onBackendSelect={handleBackendSelect}
        />
        </React.Fragment>
    )
}